module.exports = __webpack_public_path__ + "static/img/13.a6d0fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/13.png
// module id = 2sqX
// module chunks = 0